export default {
    SET_VALID: (state, payload) => {
        
        state.valid = payload;
    },
}